module.exports = __webpack_public_path__ + "assets/img/home-characterB.b57b5151.png";